import Routing from "./Routes/Routing";
import "bootstrap/dist/css/bootstrap.min.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { ParentProvider } from "./APIContext/ParentContext";
import { PlayerAccountProvider } from "./APIContext/PlayerAccountContext";
import { BookSessionProvider } from "./APIContext/BookSessionContext";
import { PaymentProvider } from "./APIContext/PaymentContext";
import "./App.css";
import { useLogin } from "./APIContext/LoginContext";
import { NotificationProvider } from "./APIContext/NotificationContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { InstructionsContextProvider } from "./APIContext/InstructionsContext";
import { NewUserContextProvider } from "./APIContext/NewUserContext";
import ScrollToTop from "./ScrollToTop";
import { Navbar } from "react-bootstrap";
import NavbarCustom from "./Components/NavbarCustom";
import { STRIPE_PUBLISHABLE_KEY } from "./Config/Config";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { SummerCampProvider } from "./APIContext/summerCampContext";
import { useLocation } from "react-router-dom";
const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

function App() {
  const { user } = useLogin();
  const navigate = useNavigate();

  const location = useLocation();

 

  // useEffect(() => {
  //   const handleTabClose = () => {
  //     localStorage.clear();
  //   };

  //   window.addEventListener("beforeunload", handleTabClose);

  //   return () => window.removeEventListener("beforeunload", handleTabClose);
  // }, []);

  return (
    <ParentProvider user={user}>
      <PlayerAccountProvider>
        <Elements stripe={stripePromise}>
          <BookSessionProvider>
            <PaymentProvider>
              <NewUserContextProvider>
                <SummerCampProvider>
                  <InstructionsContextProvider>
                    <NotificationProvider user={user}>
                      <ScrollToTop />
                      <NavbarCustom />
                      <Routing />
                    </NotificationProvider>
                  </InstructionsContextProvider>
                </SummerCampProvider>
              </NewUserContextProvider>
            </PaymentProvider>
          </BookSessionProvider>
        </Elements>
      </PlayerAccountProvider>
    </ParentProvider>
  );
}

export default App;
